import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { TwitterPicker } from 'react-color';
import reactCSS from 'reactcss';
export default class ColorPicker extends Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            this.setState({ displayColorPicker: !this.state.displayColorPicker });
        };
        this.handleClose = () => {
            this.setState({ displayColorPicker: false });
        };
        this.handleChange = (color) => {
            this.props.onChange(color.hex);
            this.setState({ color: color.hex });
        };
        this.state = {
            displayColorPicker: false,
            color: this.props.color,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.color !== this.state.color) {
            this.setState({ color: nextProps.color });
        }
    }
    render() {
        const styles = reactCSS({
            default: {
                color: {
                    width: '40px',
                    height: '10px',
                    borderRadius: '2px',
                    background: `${this.state.color}`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                    marginLeft: '10px',
                    float: 'left',
                },
                popover: {
                    position: 'absolute',
                    zIndex: 2,
                    marginTop: '30px',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
                colorName: {
                    display: 'block',
                    float: 'left',
                    marginLeft: '5px',
                    fontWeight: 600,
                    color: '#676767',
                },
                holder: {
                    display: 'block',
                    overflow: 'hidden',
                    padding: '2px 0',
                },
            },
        });
        return (_jsxs("div", Object.assign({ className: "dixa-color-picker", style: styles.holder }, { children: [_jsx("div", Object.assign({ "data-testid": "swatch", style: styles.swatch, onClick: this.handleClick }, { children: _jsx("div", { style: styles.color }) })), _jsx("span", Object.assign({ style: styles.colorName }, { children: this.state.color })), this.state.displayColorPicker === true ? (_jsxs("div", Object.assign({ style: styles.popover, "data-testid": "popover" }, { children: [_jsx("div", { style: styles.cover, onClick: this.handleClose, "data-testid": "close" }), _jsx(TwitterPicker, { width: 285, color: this.state.color, colors: [
                                '#80B1EA',
                                '#3D62AF',
                                '#F8E81C',
                                '#FF995B',
                                '#FF4F3F',
                                '#7ED321',
                                '#21A675',
                                '#B780CA',
                                '#8E1CF2',
                                '#4A4A4A',
                            ], onChange: this.handleChange })] }))) : null] })));
    }
}
